import Vue from 'vue'
import Router from 'vue-router';
import Home from './page/home/Home.vue';
import Contact from './page/contact/Contact.vue';
import Login from './page/login/Login.vue';
import Register from './page/register/Register.vue';
import ForgetSix from './page/login/common/ForgetSix.vue';
import Agreement from './page/common/Agreement.vue';
import SetWithdraw from './page/common/SetWithdraw.vue';
import NotFound from './page/common/NotFound.vue';
// 【测试模板】
import test from './page/common/test.vue';
// login下的子路由
import Platform from '@/page/login/components/Platform.vue';
import LoginDeal from '@/page/login/components/LoginDeal.vue';
import LoginAccount from '@/page/login/components/LoginAccount.vue';
import LoginData from '@/page/login/components/LoginData.vue';
import LoginProduct from '@/page/login/components/LoginProduct.vue';
import LoginAudit from '@/page/login/common/LoginAudit.vue';
import Notice from '@/page/login/common/Notice.vue';
// login下的幫助中心
import Help from './page/common/Help.vue';

// login下的子路由 【交易中心】 的子路由
import LoginDealIndex from '@/page/login/components/LoginDealComponents/LoginDealIndex.vue';
import LoginDealRecharge from '@/page/login/components/LoginDealComponents/LoginDealRecharge.vue';
import LoginDealRefund from '@/page/login/components/LoginDealComponents/LoginDealRefund.vue';
import LoginDealInquire from '@/page/login/components/LoginDealComponents/LoginDealInquire.vue';
import LoginDealRefundSetting from '@/page/login/components/LoginDealComponents/LoginDealRefundSetting.vue';
import LoginDealSettlement from '@/page/login/components/LoginDealComponents/LoginDealSettlement.vue';
import LoginDealBills from '@/page/login/components/LoginDealComponents/LoginDealBills.vue';
import LoginDealMoneyBills from '@/page/login/components/LoginDealComponents/LoginDealMoneyBills.vue';
import LoginDealRecord from '@/page/login/components/LoginDealComponents/LoginDealRecord.vue';
import LoginDealShift from '@/page/login/components/LoginDealComponents/LoginDealShift.vue';
import LoginDealRollOff from '@/page/login/components/LoginDealComponents/LoginDealRollOff.vue';
import LoginDealStatement from '@/page/login/components/LoginDealComponents/LoginDealStatement.vue';
import LoginDealFreeze from '@/page/login/components/LoginDealComponents/LoginDealFreeze.vue';
import LoginDealCertificates from '@/page/login/components/LoginDealComponents/LoginDealCertificates.vue';
// login下的子路由 【賬戶中心】的子路由
import LoginAccountIndex from '@/page/login/components/LoginAccountComponents/LoginAccountIndex.vue';
import LoginAccountPassword from '@/page/login/components/LoginAccountComponents/LoginAccountPassword.vue';
import LoginAccountTransaction from '@/page/login/components/LoginAccountComponents/LoginAccountTransaction.vue';
import LoginAccountDeal from '@/page/login/components/LoginAccountComponents/LoginAccountDeal.vue';
import LoginAccountOperate from '@/page/login/components/LoginAccountComponents/LoginAccountOperate.vue';
import LoginAccountReserve from '@/page/login/components/LoginAccountComponents/LoginAccountReserve.vue';
import LoginBusiness from '@/page/login/components/LoginBusinessComponents/LoginBusiness.vue';
import LoginBseller from '@/page/login/components/LoginBusinessComponents/LoginBseller.vue';
import LoginBbalance from '@/page/login/components/LoginBusinessComponents/LoginBbalance.vue';
import LoginBapi from '@/page/login/components/LoginBusinessComponents/LoginBapi.vue';
import LoginBuAccount from '@/page/login/components/LoginBusinessComponents/LoginBuAccount.vue';
import LoginBJurisdiction from '@/page/login/components/LoginBusinessComponents/LoginBJurisdiction.vue';
import LoginBusinessBill from '@/page/login/components/LoginBusinessComponents/LoginBusinessBill.vue';
import LoginBusinessHighest from '@/page/login/components/LoginBusinessComponents/LoginBusinessHighest.vue';
import LoginBusinessReplace from '@/page/login/components/LoginBusinessComponents/LoginBusinessReplace.vue';
import LoginSafe from '@/page/login/components/LoginSafe/LoginSafe.vue';
import LoginSecurity from '@/page/login/components/LoginSecurityComponents/LoginSecurity.vue';
// login下的子路由 【賬戶中心】未完成子路由
import LoginComplaints from '@/page/login/components/loginNotperfect/LoginComplaints.vue';
import LoginViolation from '@/page/login/components/loginNotperfect/LoginViolation.vue';
import LoginOnline from '@/page/login/components/loginNotperfect/LoginOnline.vue';
import LoginCustomer from '@/page/login/components/loginNotperfect/LoginCustomer.vue';

// login下的子路由 【數據中心】 的子路由
import LoginDataRealTime from '@/page/login/components/LoginDataComponents/LoginDataRealTime.vue';
import LoginDataHistory from '@/page/login/components/LoginDataComponents/LoginDataHistory.vue';

// login下的子路由 【產品中心】 的子路由
import LoginProductIndex from '@/page/login/components/LoginProductComponents/LoginProductIndex.vue';
import LoginProductDevelop from '@/page/login/components/LoginProductComponents/LoginProductDevelop.vue';


Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			// 首页
			path: '/',
			name: 'home',
			component: Home
		},
		{
			// 测试
			path: '/test/:id',
			component: test
		},
		{
			path: '/home',
			redirect: '/'
		},
		{
			// 产品
			path: '/product',
			name: 'product',
			component: () => import('./page/product/Product.vue')
		},
		{
			// 聯絡我們
			path: '/contact',
			name: 'Contact',
			component: Contact
		},
		{
			// 登入-設置提現：
			path: '/setwithdraw',
			component: SetWithdraw,
			meta: {
				isLogin: true,
			},
		},
		{
			// 登入-login
			path: '/login',
			component: Login,
			meta: {
				isLogin: true,
			},
			// login下的子路由
			children: [{
					path: '',
					component: Platform,
					meta: {
						isLogin: true,
					},
				},{
					// 登入-协议
					path: 'agreement',
					component: Agreement,
					meta: {
						isLogin: true,
					},
				},{
					path: 'help',
					component: Help,
					meta: {
						isLogin: true,
					},
				},{
					path: 'loginaudit',
					component: LoginAudit,
					meta: {
						isLogin: true,
					},
				},{
					// 平台公告：
					path: 'notice',
					component: Notice,
					meta: {
						isLogin: true,
					},
				},{
					// 交易中心
					path: 'deal',
					component: LoginDeal,
					children: [{
						// 交易订单
						path: '',
						component: LoginDealIndex,
						meta: {
							isLogin: true,
						},
					},{
						path: 'recharge',
						component: LoginDealRecharge,
						meta: {
							isLogin: true,
						},
					},{
						// 忘记密码
						path: 'forget',
						component: ForgetSix,
						meta: {
							isLogin: true,
						},
					},{
						// 申请退款
						path: 'refund',
						component:LoginDealRefund,
						meta: {
							isLogin: true,
						},
						
					},{
						// 退款查询
						path: 'inquire',
						component:LoginDealInquire,
						meta: {
							isLogin: true,
						},
					},{
						// 退款设定
						path: 'setting',
						component:LoginDealRefundSetting,
						meta: {
							isLogin: true,
						},
					},{
						// 結算管理
						path: 'settlement',
						component:LoginDealSettlement,
						meta: {
							isLogin: true,
						},
					},{
						// 交易帳單
						path: 'bills',
						component:LoginDealBills,
						meta: {
							isLogin: true,
						},
					},{
						// 資金帳單
						path: 'moneybills',
						component:LoginDealMoneyBills,
						meta: {
							isLogin: true,
						},
					},{
						// 儲值/轉入
						path: 'shift',
						component:LoginDealShift,
						meta: {
							isLogin: true,
						},
					},{
						// 提現/轉出
						path: 'rolloff',
						component:LoginDealRollOff,
						meta: {
							isLogin: true,
						},
					},{
						// 轉出/轉入記錄
						path: 'record',
						component:LoginDealRecord,
						meta: {
							isLogin: true,
						},
					},{
						// 帳戶流水
						path: 'statement',
						component:LoginDealStatement,
						meta: {
							isLogin: true,
						},
					},{
						// 凍結資金管理
						path: 'freeze',
						component:LoginDealFreeze,
						meta: {
							isLogin: true,
						},
					},{
						// 電子憑證
						path: 'certificates',
						component:LoginDealCertificates,
						meta: {
							isLogin: true,
						},
					}]
				},
				{
					// 賬戶中心
					path: 'account',
					component: LoginAccount,
					children: [{
							// 
							path: '',
							component: LoginAccountIndex,
							meta: {
								isLogin: true,
							},
						},
						{
							// 忘记密码
							path: 'forget',
							component: ForgetSix,
							meta: {
								isLogin: true,
							},
						},
						{
							// 安全绑定
							path: 'bindings',
							component: LoginSecurity,
							meta: {
								isLogin: true,
							},
						},
						{
							//修改登入密码
							path: 'loginap',
							component: LoginAccountPassword,
							meta: {
								isLogin: true,
							},
						},
						{
							//修改交易密码
							path: 'loginat',
							component: LoginAccountTransaction,
							meta: {
								isLogin: true,
							},
						}, {
							//重设交易密码
							path: 'loginadl',
							component: LoginAccountDeal,
							meta: {
								isLogin: true,
							},
						}, {
							//查看操作記錄
							path: 'loginao',
							component: LoginAccountOperate,
							meta: {
								isLogin: true,
							},
						}, {
                            //查看预留信息
                            path: 'loginar',
							component: LoginAccountReserve,
							meta: {
								isLogin: true,
							},
						}, {
							//修改綁定手機
							path: 'loginbh',
							component: LoginBusinessHighest,
							meta: {
								isLogin: true,
							},
						}, {
							//修改綁定郵箱
							path: 'loginbr',
							component: LoginBusinessReplace,
							meta: {
								isLogin: true,
							},
						}, {
							//商家资讯
							path: 'loginbu',
							component: LoginBusiness,
							meta: {
								isLogin: true,
							},
						}, {
							//安全中心
							path: 'loginsafe',
							component: LoginSafe,
							meta: {
								isLogin: true,
							},
						}, {
							//修改商家资讯
							path: 'loginbseller',
							component: LoginBseller,
							meta: {
								isLogin: true,
							},
						}, {
							//修改结算资讯
							path: 'loginbalan',
							component: LoginBbalance,
							meta: {
								isLogin: true,
							},
						}, {
							//發票資訊
							path: 'loginbbill',
							component: LoginBusinessBill,
							meta: {
								isLogin: true,
							},
						}, {
							//api安全
							path: 'loginbapi',
							component: LoginBapi,
							meta: {
								isLogin: true,
							},
						}, {
							//權限設置
							path: 'loginbjtion',
							component: LoginBJurisdiction,
							meta: {
								isLogin: true,
							},
						}, {
							//帳戶設定
							path: 'loginbuaccount',
							component: LoginBuAccount,
							meta: {
								isLogin: true,
							},
						}, {
							//消費者投訴
							path: 'logincomplaints',
							component: LoginComplaints,
							meta: {
								isLogin: true,
							},
						}, {
							//違規記錄
							path: 'loginviolation',
							component: LoginViolation,
							meta: {
								isLogin: true,
							},
						}, {
							//申訴留言
							path: 'loginonline',
							component: LoginOnline,
							meta: {
								isLogin: true,
							},
						}, {
							//線上客服
							path: 'logincustomer',
							component: LoginCustomer,
							meta: {
								isLogin: true,
							},
						},
					]
				},
				{
					// 数据中心
					path: 'data',
					component: LoginData,
					children:[{
						//實時交易數據
						path: '',
						component: LoginDataRealTime,
						meta: {
							isLogin: true,
						},
					},{
						//歷史交易數據
						path: 'history',
						component: LoginDataHistory,
						meta: {
							isLogin: true,
						},
					}]
				},{
					// 产品中心
					path: 'product',
					component: LoginProduct,
					children:[{
						//我的產品
						path: '',
						component: LoginProductIndex,
						meta: {
							isLogin: true,
						},
					},{
						path: 'loginpdeve',
						component: LoginProductDevelop,
						meta: {
							isLogin: true,
						},
					}]
				}
			]},
		{
			// 注册
			path: '/register',
			name: 'register',
			component: Register
		},
		{
			// 404
			path: '*',
			component: NotFound
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})
